import React, { useMemo, useState } from 'react'
import { Alert, Form, Spinner } from 'react-bootstrap';
import { useGetNewsletterSubscribers } from '../../../api/main-site-newsletter-subscriber/newsletter-subscriber.hooks';

const NewsletterSubscriber = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: newsletterSubscribers, isLoading, error } = useGetNewsletterSubscribers();

  console.log(newsletterSubscribers)

  const subscribers = useMemo(() => {
    if (!Array.isArray(newsletterSubscribers)) {
      return [];
    }

    return [...newsletterSubscribers].sort((a, b) => {
      const dateA = new Date(a?.subscribedAt || 0).getTime();
      const dateB = new Date(b?.subscribedAt || 0).getTime();
      return dateB - dateA;
    });
  }, [newsletterSubscribers]);

  const filteredSubscribers = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    if (!term) {
      return subscribers;
    }

    return subscribers.filter((subscriber) => {
      const email = subscriber?.email || '';
      const subscribedAt = subscriber?.subscribedAt || '';

      return `${email} ${subscribedAt}`.toLowerCase().includes(term);
    });
  }, [searchTerm, subscribers]);

  const formatSubscribedAt = (value) => {
    if (!value) {
      return '-';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return date.toLocaleString();
  };

  return (
    <div className="col-12">
      {error && (
        <Alert variant="danger" className="mb-3">
          Failed to load newsletter subscribers.
        </Alert>
      )}

      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h4 className="card-title m-0">
            Newsletter Subscribers {!isLoading && `(${filteredSubscribers.length})`}
          </h4>

          <Form.Control
            type="search"
            placeholder="Search by email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ maxWidth: '280px' }}
          />
        </div>

        <div className="card-body">
          {isLoading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Email</th>
                    <th>Subscribed At</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSubscribers.map((subscriber, index) => (
                    <tr key={subscriber?.id || subscriber?._id || `${subscriber?.email || 'subscriber'}-${index}`}>
                      <td>{index + 1}</td>
                      <td>{subscriber?.email || '-'}</td>
                      <td>{formatSubscribedAt(subscriber?.subscribedAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {!isLoading && filteredSubscribers.length === 0 && (
            <div className="text-center py-4">
              <p className="text-muted mb-0">
                {searchTerm ? 'No subscribers found.' : 'No newsletter subscribers found.'}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default NewsletterSubscriber